/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.benefits.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.membership.benefits.modals.remove.controllers',
  'acme.view.application.membership.benefits.modals.create.controllers'
])

.controller('MembershipBenefitsController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'PermissionsService', 'GridStateFactory', 'GridDefinitionFactory', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, ApiService, PermissionsService, GridStateFactory, GridDefinitionFactory, NoticeFactory) {

    $scope.membershipBenefits = {

      model: [
        {
          id: '1',
          description: '$5 bucks off'
        },
        {
          id: '2',
          description: '$15 bucks off'
        },
        {
          id: '3',
          description: '$25 bucks off'
        },
        {
          id: '4',
          description: '$35 bucks off'
        },
        {
          id: '5',
          description: '$45 bucks off'
        }
      ],

      gridName: $state.current.name+'.grid0',
      searchQuery: '',
      searchTimer: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      optionsOverride: {
        enableRowSelection: false,
        multiSelect: false,
        noUnselect: false,
        enableGridMenu: false,
        data: 'membershipBenefits.model',
        appScopeProvider: {
          onDblClick: function(row) {
            $scope.membershipBenefits.onGridDoubleClick(row.entity);
          },
          remove: function(id) {
            $scope.membershipBenefits.remove(id);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.membershipBenefits.onDataGridPaginate(newPageNumber, newPageSize);
          },
          onDataGridColumnReordered: function(column, originalPosition, newPosition, columns) {
            $scope.membershipBenefits.onDataGridColumnReordered(column, originalPosition, newPosition, columns);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.membershipBenefits.onDataGridSortChange(grid, columns);
          },
          onDataGridColumnChanged: function(changedColumn, columns) {
            $scope.membershipBenefits.onDataGridColumnChanged(changedColumn, columns);
          },
          onDataGridSelectionChange: function (row, e) {
            $scope.membershipBenefits.onDataGridSelectionChange(row, e);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'edit',
            displayName: 'Edit',
            width: 60,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDoubleClick(row.entity)" role="link">Edit<span class="sr-only"> Benefit</span></a></div>',
            onCellNavClick: function(row, col) {
              $scope.membershipBenefits.onGridDoubleClick(row.entity);
            },
            visible: true
          },
          {
            field: 'description',
            displayName: 'Benefit',
            onCellNavClick: function(row, col) {
              $scope.membershipBenefits.onGridDoubleClick(row.entity);
            },
            visible: true
          },
          {
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            onCellNavClick: function(row, col) {
              $scope.membershipBenefits.remove(row.entity.id);
            },
            visible: true
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Membership Benefits',
          buttonRight: {
            permissions: 'MEMBERSHIP_CATEGORY_CREATE',
            label: 'New Benefit',
            action: function() {
              $scope.membershipBenefits.create();
            }
          }

        });

        this.gridDefinition.init(this.gridName, this.optionsOverride);
        this.gridDefinition.setColumns(this.optionsOverride.columnDefs, null);
        this.gridDefinition.options.totalItems = this.model.length;
        this.gridDefinition.isLoaded = true;
        $timeout(function() {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: $scope.membershipBenefits.gridDefinition.options.gridName,
            datasetLength: $scope.membershipBenefits.model.length
          });
        }, 10);

      },

      getBenefits: function() {
        ApiService.membership.benefits.list(this.gridState.getGridState()).then(this.success.getBenefits, this.error.getBenefits);
      },

      findBenefit: function(id) {
      
        var i, ii,
            r = false;
      
        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              benefit: this.model[i],
              index: i
            };
            break;
          }
        }
        
        return r;
        
      },

      // Handles create and update
      create: function(id) {

        var self = $scope.membershipBenefits,
            current = self.findBenefit(id);

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/benefits/modals/create/create.tpl.html',
          size: 'md',
          controller: 'MembershipBenefitsModalsCreateController',
          resolve: {
            currentBenefit: function() {
              return (current) ? current.benefit : false;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (benefit) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          if (benefit.id) {
            ApiService.membership.benefits.update(benefit).then(function(response) {
              self.model[current.index] = benefit;
              self.success.update(response);
            }, self.error.update);

          }else {
            ApiService.membership.benefits.create(benefit).then(function(response) {
              self.model.push(benefit);
              self.success.create(response);
            }, self.error.create);
          }
        }, function () {
          // Do nothing
        });

      },

      remove: function(id) {

        var self = $scope.membershipBenefits,
            current = self.findBenefit(id);

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/benefits/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipBenefitsModalsRemoveController',
          resolve: {
            currentBenefit: function() {
              return current.benefit;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isRemoving = true;

          ApiService.membership.benefits.remove(current.benefit).then(function(response) {
            self.model.splice(current.index, 1);
            self.success.remove(response);
          }, self.error.remove);
        }, function () {
          // Do nothing
        });

      },

      search: function() {
        var self = $scope.membershipBenefits;

        if (self.searchTimer) {
          $timeout.cancel(self.searchTimer);
        }

        self.searchTimer = $timeout(function() {
          self.gridState.setPropertyValue('search', self.searchQuery);
          self.getBenefits();
        }, 300);
      },

      success: {
        init: function(response) {},
        getBenefits: function(response) {
          var self = $scope.membershipBenefits;

          self.gridDefinition.isLoaded = true;
          self.gridDefinition.options.totalItems = self.model.length;

          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName,
              datasetLength: self.model.length
            });
          }, 10);

        },
        remove: function(response) {},
        create: function(response) {
          $scope.membershipBenefits.getBenefits();
        },
        update: function(response) {
          $scope.membershipBenefits.getBenefits();
        }
      },

      error: {
        init: function(response) {},
        getBenefits: function(response) {},
        remove: function(response) {},
        create: function(response) {},
        update: function(response) {}
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.membershipBenefits;

        self.gridState.updateGridState(newPage, pageSize);
        self.getBenefits();

      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.membershipBenefits,
            data = columns[0];

        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getBenefits();
        }

      },

      onDataGridColumnReordered: function (column, originalPosition, newPosition, columns) {

        var self = $scope.membershipBenefits;

        self.gridDefinition.setColumnConfig(columns);

      },

      onGridDoubleClick: function(item) {
        if (PermissionsService.check('MEMBERSHIP_CATEGORY_UPDATE')) {
          $scope.membershipBenefits.create(item.id);
        }
      }

    };

    $scope.membershipBenefits.init();

}]);